import { useI18n } from "../../utils/translate/i18n/useI18n";
import { useAuthUser } from "../../utils/useAuthUser";
import type { TestParameters } from "../../type/result";
import type { TestResultListItemProps } from "../../type/result";

export default function TestResultListItem({
  item,
  kind = "tone",
  index,
  isActive,
  formatDate,
  onClick,
}: TestResultListItemProps) {
  const { t } = useI18n();
  const user = useAuthUser();

  let testParams: TestParameters | null = null;
  try { testParams = JSON.parse(item.test_params) as TestParameters; } catch { /* ignore */ }

  const paramIcons: { key: keyof TestParameters; icon: string; label: string }[] = [
    { key: "addNoise",    icon: "bi-soundwave",        label: t("Dodaj szum") },
    { key: "continuous",  icon: "bi-volume-up-fill",   label: t("Dźwięk ciągły") },
    { key: "randomTest",  icon: "bi-shuffle",          label: t("Losowy test") },
    { key: "adaptTest",   icon: "bi-activity",         label: t("Test adaptacyjny") },
    { key: "description", icon: "bi-card-text",        label: t("Opis testu dostępny") },
  ];

  return (
    <li
      className={`user-results__list-item ${isActive ? "is-active" : ""}`}
      onClick={onClick}
    >
      <div className="user-results__list-index">{index}</div>
      <div className="user-results__list-meta">
        <span className="user-results__list-date">
          <i className="bi bi-calendar3 me-1" />
          {formatDate(item.created_at)}
        </span>
        {user?.admin === true && item.ip_address && (
          <span className="user-results__admin-meta">
            <i className="bi bi-geo-alt me-1" />
            {item.ip_address}
          </span>
        )}
      </div>    
      {user?.admin === true && item.description && (
        <span
          className="user-results__list-ai-icon"
          title={t("Dostępny opis")}
          aria-label={t("Dostępny opis")}
        >
          <i className="bi bi-card-text" />
        </span>
      )}
      {kind === "tone" && testParams && paramIcons.map(({ key, icon, label }) =>
        testParams![key] ? (
          <span key={key} className="user-results__list-ai-icon" title={label} aria-label={label}>
            <i className={`bi ${icon}`} />
          </span>
        ) : null
      )}
      {item.ai_analysis && (
        <span
          className="user-results__list-ai-icon"
          title={t("Analiza AI dostępna")}
          aria-label={t("Analiza AI dostępna")}
        >
          ✨
        </span>
      )}
    </li>
  );
}
